import { STYLE_OPTIONS } from 'src/constants';

const color = '#393939';
const fontFamily = STYLE_OPTIONS.FONT_FAMILY;

const filterFormStyle = () => ({
  root: {
    '& .MuiInputBase-root, & .MuiFormLabel-root': {
      fontSize: '14px',
    },
  },

  groupLabel: {
    color,
    fontFamily,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '28px',
  },

  line: {
    width: '100%',
    height: 1,
    background: STYLE_OPTIONS.COLOR_BLUE,
    marginTop: 24,
    marginBottom: 16,
  },

  gridMorePadding: {
    paddingTop: 10,
  },
});

export default filterFormStyle;
